export default "__VITE_ASSET__DxVmm_UJ__"